module.exports = __webpack_public_path__ + "static/img/banner_5_m.29320e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/otherpage/banner_5_m.png
// module id = 75ZZ
// module chunks = 1